<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Default look and feel" />
    <vc-cookie-consent
      read-button-tag="router-link"
      :cookie-days="-1"
      cookie-name="__vc_cookie_consent_text_cookie__"
      read-button-to="/cookie-policy">We use cookies to ensure you get the best experience</vc-cookie-consent>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'CookieConsentPage',
  data () {
    return {
      title: null,
      description: null
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cookie-consent.vue